<template>
    <b-row class="product-files">
        <div class="col-12 mb-3">
            <strong>
                <font-awesome-icon icon="file"></font-awesome-icon>
                {{ title }}
            </strong>
        </div>
        <viewer :options="viewerOptions" class="col-md-12 row">
            <b-col
                md="2"
                v-for="file in files"
                :key="file.id"
                v-b-tooltip.hover
                :title="file.file_name"
            >
                <div class="file">
                    <img
                        v-if="isImage(file.file_type)"
                        class="file-preview file-image"
                        :src="file.square"
                        :data-source="file.url"
                    />
                    <div
                        v-else
                        class="file-preview file-icon"
                        :class="`${getFileTypeClass(file.file_type)}`"
                        @click="openFile(file)"
                    ></div>
                    <div class="file-name">{{ file.file_name }}</div>
                </div>
            </b-col>
        </viewer>
    </b-row>
</template>

<script>
import { getFileTypeClass } from "../../../plugins/utilities";
import Viewer from "v-viewer/src/component.vue";

export default {
  props: {
    files: Array,
    title: String
  },
  components: {
    Viewer
  },
  data() {
    return {
      defectPhotos: [],
      viewerOptions: {
        toolbar: {
          zoomIn: 4,
          zoomOut: 4,
          oneToOne: 4,
          reset: 4,
          prev: 4,
          play: {
            show: 4,
            size: "large"
          },
          next: 4,
          rotateLeft: false,
          rotateRight: false,
          flipHorizontal: false,
          flipVertical: false
        },
        url: "data-source"
      }
    };
  },
  name: "FileItems",
  methods: {
    isImage(file_type) {
      if (file_type.startsWith("image/")) {
        return true;
      } else {
        return false;
      }
    },
    getFileTypeClass,
    openFile(file) {
      window.open(file.url);
    }
  }
};
</script>

<style scoped>
</style>
